import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';
import ScrollFadeWrapper from '../../components/ScrollFadeWrapper/ScrollFadeWrapper';

import PartnerBrandsComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/Internet/partnerBrandsData.json';

import ScrollingCardsComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsData from '../../json/components/HomePages/Internet/scrollingCardsData.json';

import CustomerReviewsComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsComponent';
import CustomerReviewsMobileComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsMobileComponent';
import customerReviewsData from '../../json/components/HomePages/Internet/customerReviewsData.json';

import ExpertQuotesComponent from '../../components/HomePage/ExpertQuotes/ExpertQuotesComponent';
import ExpertQuotesMobileComponent from '../../components/HomePage/ExpertQuotes/ExpertQuotesMobileComponent';
import expertQuotesData from '../../json/components/HomePages/Internet/expertQuotesData.json';

import AccordionFAQComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQComponent';
import AccordionFAQMobileComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQMobileComponent';
import accordionFAQData from '../../json/components/HomePages/Internet/accordionFAQData.json';

import FourBlogCardsComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsComponent';
import FourBlogCardsMobileComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsMobileComponent';
import fourBlogCardsData from '../../json/components/HomePages/Internet/fourBlogCardsData.json';

import VerticalSeoSubjectGuideComponent from '../../components/VerticalSeoSubjectGuide/VerticalSeoSubjectGuideComponent';
import VerticalSeoSubjectMobileGuideComponent from '../../components/VerticalSeoSubjectGuide/VerticalSeoSubjectMobileGuideComponent';
import verticalSeoSubjectGuideData from '../../json/components/HomePages/Internet/verticalSeoSubjectGuideData.json';

import HippoTwoLineGenericComponent from '../../components/Banners/HippoTwoLineGenericComponent';
import HippoGenericMobileComponent from '../../components/Banners/HippoGenericMobileComponent';

function InternetPage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();
  return (
    <PageShell
      gap={{ xs: '24px', sm: '48px', md: '64px' }}
      containerSx={{ mt: 0 }}
    >
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={'/compare-fibre-deals/'}
            image={'HippoArmsCrossed'}
            title={'Not feeling connected to your deal?'}
            color={'blue'}
            buttonText={'Compare fibre deals'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={'/compare-fibre-deals/'}
            image={'HippoArmsCrossed'}
            title={'Not feeling connected to your deal?'}
            color={'blue'}
            buttonText={'Compare fibre deals'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CustomerReviewsComponent data={customerReviewsData} />
        ) : (
          <CustomerReviewsMobileComponent data={customerReviewsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <VerticalSeoSubjectGuideComponent
            data={verticalSeoSubjectGuideData}
          />
        ) : (
          <VerticalSeoSubjectMobileGuideComponent
            data={verticalSeoSubjectGuideData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ExpertQuotesComponent expertData={expertQuotesData} />
        ) : (
          <ExpertQuotesMobileComponent expertData={expertQuotesData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <AccordionFAQComponent data={accordionFAQData} />
        ) : (
          <AccordionFAQMobileComponent data={accordionFAQData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <FourBlogCardsComponent
            data={fourBlogCardsData}
            tag="fibre-internet"
          />
        ) : (
          <FourBlogCardsMobileComponent
            data={fourBlogCardsData}
            tag="fibre-internet"
          />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default InternetPage;
